var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"embed-responsive embed-responsive-16by9"},[_c('picture',{staticClass:"thumb__content embed-responsive-item",style:({ backgroundImage: ("url(" + (_vm.course.thumb) + ")")})})])}
var staticRenderFns = []

export { render, staticRenderFns }